module.exports = __webpack_public_path__ + "img/dot.c0830998.svg";